import React from 'react';
import {
  SEVERITY_LABELS, ARCHIVE_STATE_LABELS, deriveIssueDisplayStatus, describeIssueTerm, displayStatusTerm,
} from './issueConstants';
import IssueTermHelp from './IssueTermHelp';

/**
 * FE-CORR-07 FE-005: один основной бейдж состояния, выведенный из status и
 * trend, вместо двух конкурирующих («Состояние» и «Динамика»). Рядом
 * остаются важность и архив — это не состояние проблемы. Повторение
 * (occurrence_state) показывается строкой в detail, tracking_state — отдельным
 * блоком в карточке и detail.
 *
 * ТЗ V5 №15: у важности и состояния — пояснение из словаря ISSUE_TERM_HELP.
 * Заголовок пояснения — исходная подпись плашки, цвет и текст не меняются.
 */
const IssueBadges = ({ status, severity, trend, archiveState }) => {
  const display = deriveIssueDisplayStatus(status, trend);
  const displayTerm = displayStatusTerm(display.id, status, trend);
  const severityLabel = SEVERITY_LABELS[severity] || severity;
  const severityHelp = describeIssueTerm('severity', severity);
  const displayHelp = describeIssueTerm(displayTerm.field, displayTerm.code);
  return (
    <span className="oi-badges">
      <IssueTermHelp
        term={{ ...severityHelp, label: severityLabel }}
        className={`oi-badge oi-badge--sev-${severity}`}
        testId="oi-severity"
      >
        {severityLabel}
      </IssueTermHelp>
      <IssueTermHelp
        term={{ ...displayHelp, context: 'Состояние проблемы', label: display.label }}
        className={`oi-badge oi-badge--display-${display.id}`}
        testId="oi-display-status"
      >
        {display.label}
      </IssueTermHelp>
      {archiveState && archiveState !== 'active' && (
        <span className="oi-badge oi-badge--archive">{ARCHIVE_STATE_LABELS[archiveState] || archiveState}</span>
      )}
    </span>
  );
};

export default IssueBadges;
